import React, { lazy } from 'react';
import { dashRoutes } from './subrouters/Dash';
import listingCreationWizardRoutes from './subrouters/ListingCreationWizard/routes';
import { ComplextRoute } from './components/Routes/Routes';
import { authRoutes } from './subrouters/Auth';
import PremiumBuyerSubscriptionProvider from 'providers/PremiumBuyerSubscription';
import dataRoomRoutes from './subrouters/DataRoom/routes';
import DocusignUrl from './pages/DocusignUrl';
import OnboardEnterpriseMember from './pages/OnboardEnterpriseMember';
import { dealRoomRoutes } from './subrouters/DealRoomCreation';
import { editDealRoutes } from './subrouters/EditDealRoom';
import PrivateListingLanding from './pages/PrivateListingLanding';
import MagicLink from './subrouters/pages/MagicLink';
import ShareableLink from './subrouters/ShareableLink';
import ShareableLinkSendPassword from './subrouters/ShareableLink/pages/ShareableLinkSendPassword';
import EmailVerification from './pages/EmailVerification';
import RwcAnalytics from './subrouters/pages/RwcAnalytics';
import rwcEnterpriseRoutes from './subrouters/pages/RwcAnalytics/routes';
import AutoLogin from './pages/AutoLogin';
import { sellYourBusinessRoutes } from './subrouters/SellYourBusiness';

const AuthRouter = lazy(() => import('./subrouters/Auth'));
const Accountant = lazy(() => import('./pages/Accountant'));
const PremiumBuyerSubscription = lazy(
  () => import('./pages/PremiumBuyerSubscription'),
);
const ConfidentialityAgreement = lazy(
  () => import('./subrouters/Dash/pages/ConfidentialityAgreement'),
);
const ListingCreationWizard = lazy(
  () => import('./subrouters/ListingCreationWizard'),
);
const DataRoom = lazy(() => import('./subrouters/DataRoom'));
const DealRoomCreation = lazy(() => import('./subrouters/DealRoomCreation'));
const EditDealRoom = lazy(() => import('./subrouters/EditDealRoom'));
const FillRfi = lazy(() => import('./pages/FillRfi'));
const EtaForum = lazy(() => import('./pages/EtaForum'));
const EmailUnsubscribe = lazy(() => import('./pages/EmailUnsubscribe'));
const Dash = lazy(() => import('./subrouters/Dash'));
const AgreementSigning = lazy(() => import('./pages/AgreementSigning'));
const SellYourBusinessRouter = lazy(
  () => import('./subrouters/SellYourBusiness'),
);

export default [
  {
    path: 'auth',
    onlyPublic: true,
    routes: authRoutes,
    element: <AuthRouter />,
  },
  {
    path: 'email-verification',
    element: EmailVerification,
  },
  {
    path: 'accountant',
    element: <Accountant />,
  },
  {
    path: 'premium-buyer-subscription',
    element: (
      <PremiumBuyerSubscriptionProvider>
        <PremiumBuyerSubscription />
      </PremiumBuyerSubscriptionProvider>
    ),
  },
  {
    path: 'dash/confidentiality-agreement',
    authorized: true,
    element: <ConfidentialityAgreement />,
  },
  {
    path: 'dash/create-deal',
    authorized: true,
    routes: dealRoomRoutes,
    element: <DealRoomCreation />,
  },
  {
    path: 'dash/edit-deal/:id',
    authorized: true,
    routes: editDealRoutes,
    element: <EditDealRoom />,
  },
  {
    path: 'dash/create-business/:dealRoomId',
    authorized: true,
    routes: listingCreationWizardRoutes,
    element: <ListingCreationWizard />,
  },
  {
    path: 'dash/data-room/:dataRoomId',
    authorized: true,
    element: <DataRoom />,
    routes: dataRoomRoutes,
  },
  {
    path: 'docusign-url',
    element: <DocusignUrl />,
  },
  {
    path: 'agreements/sign/:token',
    element: <AgreementSigning />,
  },
  {
    path: 'filevault/:key',
    element: <FillRfi />,
  },
  {
    path: 'etaforum',
    element: <EtaForum />,
  },
  {
    path: 'email-unsubscribe',
    element: <EmailUnsubscribe />,
  },
  {
    path: 'onboard-enterprise-member',
    element: OnboardEnterpriseMember,
    onlyPublic: true,
  },
  {
    path: 'private-listing-landing/:listingId',
    element: PrivateListingLanding,
  },
  {
    path: 'magic-link',
    element: MagicLink,
  },
  {
    path: 'shareable-links/:shareableLinkId/*',
    element: ShareableLink,
  },
  {
    path: 'send-password-for-shareable-link/:shareableLinkId',
    element: ShareableLinkSendPassword,
  },
  {
    path: 'RWC',
    authorized: true,
    element: RwcAnalytics,
    routes: rwcEnterpriseRoutes,
  },
  {
    path: 'rwc/:enterpriseId',
    authorized: true,
    element: RwcAnalytics,
    routes: rwcEnterpriseRoutes,
  },
  {
    path: 'auto-login',
    element: <AutoLogin />,
  },
  {
    path: 'sell-your-business',
    routes: sellYourBusinessRoutes,
    element: <SellYourBusinessRouter />,
  },
  {
    path: '/',
    element: <Dash />,
    routes: dashRoutes,
  },
] as Array<ComplextRoute>;
